import React, { useState, useEffect } from "react";
import { Container, FormControl, Select, MenuItem, TextField, Card, Button, Typography, Grid, CardActions, LinearProgress, InputAdornment, Switch} from '@mui/material';
import { useNavigate, useParams } from "react-router-dom";
import CommonListHeader from "components/layout/list/header";
import { useSelector, useDispatch } from 'react-redux'
import { orgCreate } from 'api/org';
import {useOrgCreateMutation} from 'services/org'
import { v4 as uuidv4 } from 'uuid'
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { useOrgEditMutation, useOrgDetailsQuery } from "services/org";


var stateList = [
    {
        "name": "Alabama",
        "abbreviation": "AL"
    },
    {
        "name": "Alaska",
        "abbreviation": "AK"
    },
    {
        "name": "American Samoa",
        "abbreviation": "AS"
    },
    {
        "name": "Arizona",
        "abbreviation": "AZ"
    },
    {
        "name": "Arkansas",
        "abbreviation": "AR"
    },
    {
        "name": "California",
        "abbreviation": "CA"
    },
    {
        "name": "Colorado",
        "abbreviation": "CO"
    },
    {
        "name": "Connecticut",
        "abbreviation": "CT"
    },
    {
        "name": "Delaware",
        "abbreviation": "DE"
    },
    {
        "name": "District Of Columbia",
        "abbreviation": "DC"
    },
    {
        "name": "Federated States Of Micronesia",
        "abbreviation": "FM"
    },
    {
        "name": "Florida",
        "abbreviation": "FL"
    },
    {
        "name": "Georgia",
        "abbreviation": "GA"
    },
    {
        "name": "Guam",
        "abbreviation": "GU"
    },
    {
        "name": "Hawaii",
        "abbreviation": "HI"
    },
    {
        "name": "Idaho",
        "abbreviation": "ID"
    },
    {
        "name": "Illinois",
        "abbreviation": "IL"
    },
    {
        "name": "Indiana",
        "abbreviation": "IN"
    },
    {
        "name": "Iowa",
        "abbreviation": "IA"
    },
    {
        "name": "Kansas",
        "abbreviation": "KS"
    },
    {
        "name": "Kentucky",
        "abbreviation": "KY"
    },
    {
        "name": "Louisiana",
        "abbreviation": "LA"
    },
    {
        "name": "Maine",
        "abbreviation": "ME"
    },
    {
        "name": "Marshall Islands",
        "abbreviation": "MH"
    },
    {
        "name": "Maryland",
        "abbreviation": "MD"
    },
    {
        "name": "Massachusetts",
        "abbreviation": "MA"
    },
    {
        "name": "Michigan",
        "abbreviation": "MI"
    },
    {
        "name": "Minnesota",
        "abbreviation": "MN"
    },
    {
        "name": "Mississippi",
        "abbreviation": "MS"
    },
    {
        "name": "Missouri",
        "abbreviation": "MO"
    },
    {
        "name": "Montana",
        "abbreviation": "MT"
    },
    {
        "name": "Nebraska",
        "abbreviation": "NE"
    },
    {
        "name": "Nevada",
        "abbreviation": "NV"
    },
    {
        "name": "New Hampshire",
        "abbreviation": "NH"
    },
    {
        "name": "New Jersey",
        "abbreviation": "NJ"
    },
    {
        "name": "New Mexico",
        "abbreviation": "NM"
    },
    {
        "name": "New York",
        "abbreviation": "NY"
    },
    {
        "name": "North Carolina",
        "abbreviation": "NC"
    },
    {
        "name": "North Dakota",
        "abbreviation": "ND"
    },
    {
        "name": "Northern Mariana Islands",
        "abbreviation": "MP"
    },
    {
        "name": "Ohio",
        "abbreviation": "OH"
    },
    {
        "name": "Oklahoma",
        "abbreviation": "OK"
    },
    {
        "name": "Oregon",
        "abbreviation": "OR"
    },
    {
        "name": "Palau",
        "abbreviation": "PW"
    },
    {
        "name": "Pennsylvania",
        "abbreviation": "PA"
    },
    {
        "name": "Puerto Rico",
        "abbreviation": "PR"
    },
    {
        "name": "Rhode Island",
        "abbreviation": "RI"
    },
    {
        "name": "South Carolina",
        "abbreviation": "SC"
    },
    {
        "name": "South Dakota",
        "abbreviation": "SD"
    },
    {
        "name": "Tennessee",
        "abbreviation": "TN"
    },
    {
        "name": "Texas",
        "abbreviation": "TX"
    },
    {
        "name": "Utah",
        "abbreviation": "UT"
    },
    {
        "name": "Vermont",
        "abbreviation": "VT"
    },
    {
        "name": "Virgin Islands",
        "abbreviation": "VI"
    },
    {
        "name": "Virginia",
        "abbreviation": "VA"
    },
    {
        "name": "Washington",
        "abbreviation": "WA"
    },
    {
        "name": "West Virginia",
        "abbreviation": "WV"
    },
    {
        "name": "Wisconsin",
        "abbreviation": "WI"
    },
    {
        "name": "Wyoming",
        "abbreviation": "WY"
    }
]


const OrgEdit = (props) => {
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const navi = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();
    const org = useSelector(state=>state.org.create);
    const [disableButton, setDisableButton] = useState(false);
    const [validEmail, setValidEmail] = useState(false);
    const [invalidEmail, setInValidEmail] = useState(false);
    const [emailStatus, setEmailStatus] =  useState('');
    const [ orgEditMutation, { isLoading: isUpdating }] = useOrgEditMutation(); 

    const handleCancel = () =>{
        navi("/orgs/list")
    }

    const handleDelete = () =>{
        navi("/orgs/list")
    }

    const {orgDetails, orgStatus, orgLoading, fetching} = useOrgDetailsQuery({id: id}, 
        {
          selectFromResult: ({ data, status, isLoading, isFetching }) => ({
            orgDetails: data || {},
            orgStatus: status,
            orgLoading: isLoading,
            fetching: isFetching
          })
        }
    );

    useEffect(()=>{
        if(orgDetails.id){
            console.log(orgDetails)
            dispatch(orgCreate(orgDetails));
            setValidEmail(true)
        }
    }, [orgDetails])
        
    const onNameChange = (event) =>{
        dispatch(orgCreate({name: event.target.value}))
    }

    const onCodeChange = (event) =>{
        if(event.target.value !== ' '){
            dispatch(orgCreate({code: event.target.value}))
        } else {

        }
    }

    const onEmailChange = (event) =>{
        dispatch(orgCreate({email: event.target.value}))
    }

    const onStatusChange = (event) =>{
        dispatch(orgCreate({status: event.target.checked}))
    }

    const onEmailBlur = (event) =>{
        
        if(regex.test(event.target.value)){
            console.log('reached', event.target.value)
            setInValidEmail(false);
            setEmailStatus('')
            setValidEmail(true);
        } else {
            setInValidEmail(true);
            setEmailStatus('Invalid E-Mail')
            setValidEmail(false);
        }
    }

    const onPhoneChange = (value) =>{
        var phone = value;
        var phone_number = `+1${value}`;
        if(org.phone.length<11){
            dispatch(orgCreate({phone: phone}));
            dispatch(orgCreate({phone_number: phone_number}));
        }
    }

    const onZipChange = (value) =>{
        if(value.length<6){
            dispatch(orgCreate({zip: value}));
        }
    }

    const onSave = () =>{
        var record = {
            "doc":{
                ...org
            }
            
        }
        if(validEmail && emailStatus===''){
            setDisableButton(true);
            orgEditMutation(record)
            .unwrap()
            .then(result=>{
                setDisableButton(false);
            })
            .catch(err=>{
                setDisableButton(false);
            })
        }
    }

    return (
        <React.Fragment>
            <CommonListHeader value = {{title: `Edit Organization: ${orgDetails.name}`, description: "You are editing organization details."}} />
            <Container maxWidth={'md'}>
                <Card>
                    {disableButton?<LinearProgress />:''}
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">Organization Name</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <TextField 
                                variant="outlined" 
                                fullWidth
                                onChange={onNameChange}
                                value={org.name || ''}  
                            />
                        </Grid>
                    </Grid>

                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">E-Mail</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <TextField 
                                variant="outlined" 
                                fullWidth
                                onChange={onEmailChange}
                                value={org.email || ''}  
                                helperText={emailStatus}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="start">
                                            {validEmail?<DoneIcon color="primary" />:invalidEmail?<CloseIcon color="warning" />:''}
                                        </InputAdornment>
                                    )
                                }}
                                onBlur={onEmailBlur}
                            />
                        </Grid>
                    </Grid>
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">Phone</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <TextField 
                                variant="outlined" 
                                type="number"
                                fullWidth
                                onChange={(event)=>onPhoneChange(event.target.value)}
                                value={org.phone || ''}  
                            />
                        </Grid>
                    </Grid>
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">Address</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <TextField 
                                variant="outlined" 
                                fullWidth
                                onChange={(event)=>dispatch(orgCreate({address: event.target.value}))}
                                value={org.address || ''}  
                            />
                        </Grid>
                    </Grid>

                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">City</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <TextField 
                                variant="outlined" 
                                fullWidth
                                onChange={(event)=>dispatch(orgCreate({city: event.target.value}))}
                                value={org.city || ''}  
                            />
                        </Grid>
                    </Grid>

                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">State</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <FormControl fullWidth>
                                
                                <Select
                                    value={org.state}
                                    onChange={(event)=>dispatch(orgCreate({state: event.target.value}))}
                                >
                                    {stateList?.map((o, i)=>
                                        <MenuItem key={i} value={o.name}>{`${o.name}`}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">Zip</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <TextField 
                                variant="outlined" 
                                type="number"
                                fullWidth
                                onChange={(event)=>onZipChange(event.target.value)}
                                value={org.zip || ''}  
                            />
                        </Grid>
                    </Grid>

                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{padding: "10px"}}>
                        <Grid item md={3}>
                            <Typography variant="body1">Status</Typography>
                        </Grid>
                        <Grid item md={9}>
                            <Switch checked={org?.status} onChange={(event)=>onStatusChange(event)}/>
                        </Grid>
                    </Grid>


                    
                    
                    <CardActions sx={{padding: "15px"}}>
                        <Button
                            disabled={disableButton}
                            variant="contained"
                            color='primary'
                            type="submit"
                            onClick={() => onSave()}
                        >
                            Submit
                        </Button>
                        <Button
                            disabled={disableButton}
                            variant="outlined"
                            type="submit"
                            onClick={() => handleCancel()}
                        >
                            Cancel
                        </Button>
                        <Typography sx={{flexGrow: 1}} />
                        <Button
                            disabled={disableButton}
                            variant="outlined"
                            type="submit"
                            onClick={() => handleDelete()}
                            color={'warning'}
                        >
                            delete
                        </Button>
                    </CardActions>
                </Card>
            </Container>
        </React.Fragment>
    )

    
}

export default OrgEdit;